export interface IInventoryVendorManufacturerItem {
  itemId: string;
  vendorId: string;
  manufacturerId: string;
  vendorName: string;
  vendorPartNumber: string;
  manufacturerName: string;
  manufacturerPartNumber: string;
  unitPrice: number;
  unitOfMeasure: string;
}
